import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { AcceptEventTicketInvitePayload, AcceptEventTicketInviteResponse } from './event-tickets.models'

@Injectable({
  providedIn: 'root',
})
export class EventTicketsApiService extends GbBaseApiService {
  constructor(protected http: HttpClient, @Inject(APP_CONFIG) protected appConfig: any) {
    super(http, appConfig)
  }

  acceptEventTicketInvite(
    urlName: string,
    payload: AcceptEventTicketInvitePayload,
    token: string,
    eventTicketId = '',
  ): Observable<AcceptEventTicketInviteResponse> {
    return this.post<AcceptEventTicketInviteResponse>(
      `auctions/${urlName}/event-tickets/${eventTicketId}/accept/?invite_token=${token}`,
      payload,
    )
  }

  declineEventTicket(urlName: string, eventTicketId = '', token?: string): Observable<{}> {
    let url = `auctions/${urlName}/event-tickets/${eventTicketId}/decline/`
    if (token) url += `?invite_token=${token}`

    return this.post<{}>(url)
  }
}
